<template>
  <v-container fluid>
    <Navbar :title="computedTitle">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn text icon v-on="on" @click="edit = !edit">
            <v-icon>{{ editShowIcon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ editShowText }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn text icon v-on="on" @click="cancel">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </template>
        <span>Cancelar</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn text icon v-on="on" @click="save">
            <v-icon>fa-check</v-icon>
          </v-btn>
        </template>
        <span>Salvar</span>
      </v-tooltip>
    </Navbar>
    <v-card>
      <v-card-text v-show="edit">
        <div class="mb-3">
          <h4>Tags</h4>
          <template v-if="article.tags && !!article.tags.length">
            <v-chip
              v-for="tag in article.tags"
              :key="tag._id"
              :color="tag.cor"
              close
              outlined
              class="ma-1"
              @click:close="removeTag(tag)"
            >{{ tag.descricao }}</v-chip>
          </template>
          <p class="body-2 red--text mb-0" v-else>Nenhuma tag adicionada</p>
        </div>
        <!-- <DocumentForm
          :document="article"
          @cancel="cancel"
          @save="save"
        /> -->
        <v-form ref="formArticle" @submit.prevent="save">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="article.titulo"
                label="Título"
                placeholder="Título"
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="article.classificacao"
                label="Classificação"
                placeholder="Classificação"
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-select
                label="Tipo"
                v-model="article.tipo"
                return-object
                placeholder="Selecione o tipo"
                outlined
                :items="tiposArtigo"
                item-text="descricao"
                item-value="descricao"
                :rules="[rules.required]"
                no-data-text="Nenhum registro encontrado"
              ></v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-select
                label="Status"
                v-model="article.status"
                placeholder="Selecione o status"
                outlined
                :items="statusItems"
                :rules="[rules.required]"
                no-data-text="Nenhum registro encontrado"
              ></v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-autocomplete
                ref="tagRef"
                label="Tag"
                return-object
                placeholder="Selecione a tag"
                outlined
                :items="tags"
                item-text="descricao"
                item-value="_id"
                @change="changeTag"
                no-data-text="Nenhum registro encontrado"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="article.conteudo"
                label="Conteúdo"
                placeholder="Conteúdo"
                rows="10"
                row-height="25"
                auto-grow
                outlined
                :rules="[rules.required]"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-text v-show="!edit">
        <h2>{{ article.titulo }}</h2>
        <div
          v-if="article.tags && !!article.tags.length"
          class="my-3"
        >
          <v-chip
            v-for="tag in article.tags"
            :key="tag._id"
            :color="tag.cor"
            small
            outlined
            class="ma-1"
          >{{ tag.descricao }}</v-chip>
        </div>
        <div class="markdown-container">
          <div v-if="article && article.conteudo" class="conteudo" v-html="compiledMarkdown"></div>
        </div>
        <div v-if="article && article.updatedAt" class="last-update text-right">
          Atualizado em: {{ article.updatedAt | dateMonthYear }}
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import marked from 'marked';
import * as _ from 'lodash';
import Article from '../../domain/article/Article';
import DocumentForm from '../../components/document/DocumentForm';

export default {
  name: 'AddDocumentView',
  props: ['id'],
  components: {
    DocumentForm
  },
  data: () => ({
    article: new Article(),
    originalArticle: new Article(),
    statusItems: ['Em Progresso', 'Solicitar Revisão', 'Solicitar Correção', 'Publicado'],
    edit: false,
  }),
  computed: {
    ...mapGetters(['loading', 'usuario', 'isAdmin', 'tiposArtigo', 'tags', 'rules']),
    compiledMarkdown() {
      if (this.article.conteudo) return marked(this.article.conteudo);
      return '';
    },
    computedTitle() {
      return this.article._id ? 'Edita Artigo' : 'Novo Artigo';
    },
    editShowIcon() {
      return this.edit ? 'fa-eye' : 'fa-edit';
    },
    editShowText() {
      return this.edit ? 'Vizualizar' : 'Editar';
    }
  },
  methods: {
    ...mapActions([
      'fetchArticleById',
      'updateArticle',
      'createArticle',
      'deleteArticle',
      'fetchTiposArtigo',
      'fetchTags'
    ]),
    async initializeDocument() {
      if (!this.tiposArtigo.length) this.fetchTiposArtigo({});
      if (!this.tags.length) this.fetchTags();

      if (this.id) await this.inicializaEditaDocumento();
      else await this.inicializaNovoDocumento();

      this.originalArticle = JSON.parse(JSON.stringify(this.article));
    },
    removeTag(tagSelected) {
      if (confirm(`Deseja remover a tag ${tagSelected.descricao} do artigo?`)) {
        this.article.tags = this.article.tags.filter(tag => tag.descricao !== tagSelected.descricao);
      }
    },
    changeTag(obj) {
      const addTag = { ...obj };

      const tagExists = this.article.tags.find(tag => tag.descricao === addTag.descricao);

      if (!tagExists) {
        this.article.tags.push(addTag);
      } else {
        this.$store.commit('showSnackbar', { text: `Tag (${addTag.descricao}) já existe no artigo` });
      }

      this.$refs.tagRef.reset();
    },
    inicializaNovoDocumento() {
      this.article = new Article();
      this.edit = true;
    },
    async inicializaEditaDocumento() {
      await this.getArticle();
      if (!this.isAdmin && !this.autorDocumento()) { 
        this.$router.go(-1);
        this.$store.commit('showSnackbar', { text: 'Você não tem permissão para acessar esse artigo.' });
      }
    },
    autorDocumento() {
      return this.usuario._id === this.article.autor;
    },
    update: _.debounce(function(e) {
      this.input = e.target.value;
    }, 300),
    async getArticle() {
      const article = await this.fetchArticleById(this.id);
      this.article = { ...article };
    },
    isArticleModified() {
      if (this.article.titulo !== this.originalArticle.titulo) return true;
      if (this.article.classificacao !== this.originalArticle.classificacao) return true;
      if ((this.article.tipo && this.article.tipo.descricao) !== (this.originalArticle.tipo && this.originalArticle.tipo.descricao)) return true;
      if (this.article.status !== this.originalArticle.status) return true;
      if (this.article.conteudo !== this.originalArticle.conteudo) return true;
      if (this.article.tags.length !== this.originalArticle.tags.length) return true;
      return false;
    },
    cancel() {
      if (this.isArticleModified() && confirm('Existem modificações!! Tem certeza que deseja cancelar?')) {
        this.$router.go(-1);  
      } else if (!this.isArticleModified()) {
        this.$router.go(-1);
      }
    },
    save() {
      if (this.$refs.formArticle.validate()) {
        if (this.article._id && !!this.article.tags.length) {
          // Update document
          this.updArticle(this.article);
        } else if (!!this.article.tags.length) {
          // Create document
          this.addArticle(this.article);
        } else {
          this.$store.commit('showSnackbar', { text: 'Adicione pelo menos uma tag ao artigo.' });
        }
      }
    },
    async addArticle(article) {
      article.autor = this.usuario._id;
      await this.createArticle(article);
    },
    async updArticle(article) {
      await this.updateArticle(article);
    },
  },
  created() {
    this.initializeDocument();
  }
}
</script>

<style scoped>
.feedback {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  margin-top: 40px;
  box-shadow: var(--boxshadow);
}
.feedback > div {
  display: flex;
  align-items: center;
}
.feedback span {
  font-size: 1.125rem;
}
.feedback button:hover {
  color: #1976d2;
}
.last-update {
  margin-top: 40px;
  font-style: italic;
}
.conteudo {
  white-space: pre-wrap;
}
</style>